/* Jane Lushka v1.2: product card hover layer (phase 4 rewrite, collection:5, K10, K25).
 *
 * Only on (hover: hover) and (min-width: 768px); the media query `change` builds or tears everything down, so a window
 * resized across 768px or a tablet never keeps a strip. On the first pointerover or focusin of a card:
 *  1. Second photo: .jl-card__media[data-jl-img2-src][data-jl-img2-srcset] becomes <img class="jl-card__img2"> in the
 *     image link; .is-img2-ready once it has loaded (jl-card.css fades it in on hover/focus, owner P9). Never at load,
 *     never on phones or touch.
 *  2. Size strip (cards that are not sold out): div.jl-size-strip[role=group] inside .jl-card__media, sizes from
 *     window.JLSizeSheet.getData(card, productId) (the card's inline jl-size-data payload), strings from the card's
 *     data-jl-strip attribute. Click: JLSizeSheet.add(variantId, {source: 'card_strip', ...}); busy: aria-busy on the
 *     button, the other sizes inert; error: message in the strip's polite live region, a 422 marks the size sold out;
 *     success: JLSizeSheet.add itself remembers the size (K26). One-size products: one "Add to bag" button.
 *     One Tab stop per strip (roving tabindex on the first available size; arrows, Home and End move between sizes).
 *  3. No strip when it would not read (review A3, A8): more than 7 sizes, a size wider than its button, or buttons
 *     under 41px (K22). The card gets .jl-card--plus and keeps its "+" (shown on hover and focus, jl-card.css); gift
 *     cards get that class from product-card.liquid. A density toggle or a resize decides again on the next hover.
 * Everything is delegated on document, so cards added by filters, load more, Recently viewed, the Wishlist page or the
 * theme editor need no re-binding. No LimeSpot branch, no /products/<handle>.js fetch, no storage access here (the
 * remembered size goes through JLSizeSheet).
 */
(function () {
  'use strict';

  if (window.__jlCardHover) return;
  window.__jlCardHover = 1;

  var mq = window.matchMedia ? window.matchMedia('(hover: hover) and (min-width: 768px)') : null;
  var MAX_SIZES = 7;
  var MIN_BTN = 41;

  function on() {
    return !!(mq && mq.matches);
  }

  function strings(media) {
    var s = {};
    try {
      s = JSON.parse(media.getAttribute('data-jl-strip') || '{}') || {};
    } catch (e) {
      s = {};
    }
    return s;
  }

  function fill(tpl, name, size) {
    return String(tpl || '').replace('[name]', name || '').replace('[size]', size || '');
  }

  /* ---------- second photo ---------- */

  function attachImg2(card) {
    var media = card.querySelector('.jl-card__media[data-jl-img2-src]');
    if (!media || media.querySelector('.jl-card__img2')) return;
    var link = media.querySelector('.jl-card__img-link');
    var first = media.querySelector('.jl-card__img');
    if (!link) return;
    var img = document.createElement('img');
    img.className = 'jl-card__img2';
    img.alt = '';
    img.decoding = 'async';
    img.width = 600;
    img.height = 800;
    img.addEventListener('load', function () {
      media.classList.add('is-img2-ready');
    }, { once: true });
    var sizes = first && first.getAttribute('sizes');
    if (sizes) img.setAttribute('sizes', sizes);
    var srcset = media.getAttribute('data-jl-img2-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.src = media.getAttribute('data-jl-img2-src');
    link.appendChild(img);
  }

  /* ---------- strip ---------- */

  function soldOutContent(btn, size, S) {
    btn.textContent = '';
    btn.removeAttribute('aria-label');
    btn.setAttribute('aria-disabled', 'true');
    var shown = document.createElement('span');
    shown.setAttribute('aria-hidden', 'true');
    shown.textContent = size;
    var hidden = document.createElement('span');
    hidden.className = 'visually-hidden';
    hidden.textContent = fill(S.sold || '[size]', S.name, size);
    btn.appendChild(shown);
    btn.appendChild(hidden);
  }

  /* every size button at least 41px wide (K22) and its text inside it; layout widths (offsetWidth), because a card
     still in the jl-motion reveal is scaled to .985 */
  function fits(strip) {
    var btns = strip.querySelectorAll('.jl-size-strip__btn');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].offsetWidth < MIN_BTN || btns[i].scrollWidth > btns[i].clientWidth + 1) return false;
    }
    return true;
  }

  /* false: this card keeps its "+" instead of a strip */
  function buildStrip(card, media, data) {
    if (media.querySelector('.jl-size-strip')) return true;
    if (!data.one && data.sizes.length > MAX_SIZES) return false;
    var S = strings(media);
    var name = S.name || data.title || '';
    S.name = name;

    var strip = document.createElement('div');
    strip.className = 'jl-size-strip';
    strip.setAttribute('role', 'group');
    strip.setAttribute('aria-label', fill(S.label || '[name]', name));
    strip.__jlData = data;
    strip.__jlS = S;

    var cap = document.createElement('span');
    cap.className = 'jl-size-strip__label';
    cap.setAttribute('aria-hidden', 'true');
    cap.textContent = S.cap || '';
    strip.appendChild(cap);

    var i;
    var btn;
    if (data.one) {
      var id = 0;
      for (i = 0; i < data.sizes.length; i++) {
        if (data.sizes[i].a && data.sizes[i].id) {
          id = data.sizes[i].id;
          break;
        }
      }
      if (!id) return true;
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jl-size-strip__btn jl-size-strip__btn--one';
      btn.setAttribute('data-variant-id', id);
      btn.setAttribute('data-size', '');
      btn.setAttribute('aria-disabled', 'false');
      btn.textContent = S.add || (data.s && data.s.add) || '+';
      strip.appendChild(btn);
    } else {
      var stop = null;
      for (i = 0; i < data.sizes.length; i++) {
        var z = data.sizes[i];
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jl-size-strip__btn';
        btn.tabIndex = -1;
        btn.setAttribute('data-variant-id', z.id || 0);
        btn.setAttribute('data-size', z.v);
        if (z.a && z.id) {
          btn.setAttribute('aria-disabled', 'false');
          btn.setAttribute('aria-label', fill(S.size || '[size]', name, z.v));
          btn.textContent = z.v;
          if (!stop) stop = btn;
        } else {
          soldOutContent(btn, z.v, S);
        }
        strip.appendChild(btn);
      }
      (stop || strip.querySelector('.jl-size-strip__btn')).tabIndex = 0;
    }

    var status = document.createElement('span');
    status.className = 'jl-size-strip__status';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    strip.appendChild(status);

    media.appendChild(strip);
    if (!data.one && !fits(strip)) {
      media.removeChild(strip);
      return false;
    }
    return true;
  }

  function attachStrip(card) {
    if (card.classList.contains('is-sold-out') || card.__jlStrip) return;
    var media = card.querySelector('.jl-card__media[data-jl-strip]');
    if (!media) return;
    var api = window.JLSizeSheet;
    if (!api || typeof api.getData !== 'function') return; /* not loaded yet: the next hover tries again */
    card.__jlStrip = 'pending';
    Promise.resolve(api.getData(card, card.getAttribute('data-product-id')))
      .then(function (data) {
        if (!card.isConnected || !on()) {
          card.__jlStrip = null;
          return;
        }
        card.__jlStrip = 'done';
        if (!data || !data.sizes || !data.sizes.length) return;
        if (!buildStrip(card, media, data)) {
          card.__jlPlus = true;
          card.classList.add('jl-card--plus');
        }
      })
      .catch(function () {
        card.__jlStrip = 'done';
      });
  }

  function prime(e) {
    if (!on()) return;
    var t = e.target;
    var card = t && t.closest ? t.closest('.jl-card--grid') : null;
    if (!card) return;
    if (!card.__jlImg2) {
      card.__jlImg2 = true;
      attachImg2(card);
    }
    attachStrip(card);
  }

  document.addEventListener('pointerover', prime, { passive: true });
  document.addEventListener('focusin', prime);

  /* roving tabindex (review A13): the strip is one Tab stop; arrows, Home and End move between its sizes, sold-out
     ones included (they read "S, sold out"), without wrapping */
  var MOVES = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: -99, End: 99 };

  function rove(btns, next) {
    for (var i = 0; i < btns.length; i++) btns[i].tabIndex = btns[i] === next ? 0 : -1;
  }

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('.jl-size-strip__btn') : null;
    if (!btn || e.altKey || e.ctrlKey || e.metaKey || !Object.prototype.hasOwnProperty.call(MOVES, e.key)) return;
    var strip = btn.closest('.jl-size-strip');
    var btns = strip ? Array.prototype.slice.call(strip.querySelectorAll('.jl-size-strip__btn')) : [];
    if (btns.length < 2) return;
    e.preventDefault();
    if (strip.__jlBusy) return;
    var next = btns[Math.max(0, Math.min(btns.length - 1, btns.indexOf(btn) + MOVES[e.key]))];
    rove(btns, next);
    next.focus();
  });

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    var strip = t && t.classList && t.classList.contains('jl-size-strip__btn') ? t.closest('.jl-size-strip') : null;
    if (strip && t.tabIndex !== 0) rove(strip.querySelectorAll('.jl-size-strip__btn'), t);
  });

  function setStatus(strip, msg) {
    var status = strip.querySelector('.jl-size-strip__status');
    if (!status) return;
    status.textContent = msg || '';
    strip.classList.toggle('has-status', !!msg);
    clearTimeout(strip.__jlStatusTimer);
    if (msg) {
      strip.__jlStatusTimer = setTimeout(function () {
        status.textContent = '';
        strip.classList.remove('has-status');
      }, 8000);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('.jl-size-strip__btn') : null;
    if (!btn) return;
    var strip = btn.closest('.jl-size-strip');
    var card = btn.closest('.jl-card');
    if (!strip || !card) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true' || strip.__jlBusy) return;
    var api = window.JLSizeSheet;
    if (!api || typeof api.add !== 'function') return;

    var data = strip.__jlData || {};
    var S = strip.__jlS || {};
    var size = btn.getAttribute('data-size') || '';
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var errorText = (data.s && data.s.error) || '';

    var others = strip.querySelectorAll('.jl-size-strip__btn');
    strip.__jlBusy = true;
    btn.setAttribute('aria-busy', 'true');
    for (var i = 0; i < others.length; i++) {
      if (others[i] !== btn) others[i].inert = true;
    }
    setStatus(strip, '');

    var done = function () {
      strip.__jlBusy = false;
      btn.removeAttribute('aria-busy');
      for (var j = 0; j < others.length; j++) others[j].inert = false;
    };

    Promise.resolve(api.add(id, {
      source: 'card_strip',
      opener: btn,
      size: size,
      productId: parseInt(card.getAttribute('data-product-id'), 10) || data.id,
      itemName: S.name || data.title || '',
      cents: data.cents
    }))
      .then(function (res) {
        /* success: JLSizeSheet.add stores the remembered size itself (K26, not for gift card amounts) */
        if (res && res.ok) return;
        if (res && res.status === 422) soldOutContent(btn, size || btn.textContent, S);
        setStatus(strip, (res && res.message) || errorText);
      })
      .catch(function () {
        setStatus(strip, errorText);
      })
      .then(done, done);
  });

  /* the card width changed (density toggle, resize): strips and the "+" fallback are decided again on the next
     hover or focus (a strip with focus or an add in flight stays) */
  function redecide() {
    var cards = document.querySelectorAll('.jl-card--grid');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__jlStrip !== 'done') continue;
      var strip = card.querySelector('.jl-size-strip');
      if (strip && (strip.__jlBusy || strip.contains(document.activeElement))) continue;
      if (strip) strip.remove();
      if (card.__jlPlus) {
        card.__jlPlus = false;
        card.classList.remove('jl-card--plus');
      }
      card.__jlStrip = null;
    }
  }

  var lastWidth = window.innerWidth;
  var widthQueued = false;
  document.addEventListener('jl:grid-view', redecide);
  window.addEventListener('resize', function () {
    if (widthQueued) return;
    widthQueued = true;
    window.requestAnimationFrame(function () {
      widthQueued = false;
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      redecide();
    });
  });

  /* leaving hover devices (resize below 768px, a tablet's pointer change): strips and second photos go */
  function teardown() {
    if (on()) return;
    var strips = document.querySelectorAll('.jl-card .jl-size-strip');
    for (var i = 0; i < strips.length; i++) strips[i].remove();
    var imgs = document.querySelectorAll('.jl-card .jl-card__img2');
    for (var k = 0; k < imgs.length; k++) {
      var media = imgs[k].closest('.jl-card__media');
      if (media) media.classList.remove('is-img2-ready');
      imgs[k].remove();
    }
    var cards = document.querySelectorAll('.jl-card');
    for (var c = 0; c < cards.length; c++) {
      cards[c].__jlImg2 = false;
      cards[c].__jlStrip = null;
      if (cards[c].__jlPlus) {
        cards[c].__jlPlus = false;
        cards[c].classList.remove('jl-card--plus');
      }
    }
  }

  if (mq) {
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', teardown);
    else if (typeof mq.addListener === 'function') mq.addListener(teardown);
  }
})();
